export const handlePromise = (p: Promise<any>) => new Promise<[any, any]>((res, _) => {
  p.then(result => res([result, null]))
  .catch(err => res([null, err]))
})

export const handlePromiseChain = (...p: Promise<any>[]) => new Promise<[any, any]>((res, _) => {
  Promise.all(p).then(results => res([results, null]))
  .catch(errors => res([null, errors]))
})